import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lakhAmount',
    standalone: false,
})
export class LakhAmountPipe implements PipeTransform {
    transform(value: number | string | null | undefined, decimal = 2): string {
        if (value === null || value === undefined || value === '') return '';

        let num = Number(value);
        if (isNaN(num)) return '';

        const isNegative = num < 0;
        num = Math.abs(num);
        if (num === 0) {
            return '0';
        }

        // Convert to lakhs
        const lakhs = num / 100000;

        // Keep 2 decimals
        const formatted = this.formatIndian(lakhs.toFixed(decimal));

        return (isNegative ? '-' : '') + formatted;
    }

    private formatIndian(value: string): string {
        const parts = value.split('.');
        let integerPart = parts[0];
        const decimalPart = parts.length > 1 ? '.' + parts[1] : '';

        const lastThree = integerPart.slice(-3);
        const otherNumbers = integerPart.slice(0, -3);

        if (otherNumbers !== '') {
            integerPart =
                otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
                ',' +
                lastThree;
        }

        return integerPart + decimalPart;
    }
}
